export interface IdentityCandidate {
  id: string;
  name: string;
  default_uom?: string;
  storage_type?: string;
  category?: string | null;
  current_batch_lot?: string | null;
  current_lot_document_date?: string | null;
}

export function importIdentityCandidates(
  line: { food_create: { name: string } },
  source: { food_match?: IdentityCandidate | null; identity_candidates?: IdentityCandidate[]; similar_foods?: IdentityCandidate[]; similar_food?: IdentityCandidate | null } | null | undefined,
  foods: IdentityCandidate[],
): IdentityCandidate[] {
  const name = line.food_create.name.trim().toLocaleLowerCase('it-IT');
  const rows = [...(source?.food_match ? [source.food_match] : []), ...(source?.identity_candidates ?? []), ...(source?.similar_foods ?? []),
    ...(source?.similar_food ? [source.similar_food] : []),
    ...foods.filter(food => name && food.name.trim().toLocaleLowerCase('it-IT') === name)];
  return [...new Map(rows.map(food => [food.id, food])).values()];
}

export function needsImportIdentityReview(
  line: { skip: boolean; food_id: string | null; new_food_confirmed?: boolean; identity_error?: boolean },
  candidates: IdentityCandidate[],
): boolean {
  return !line.skip && !line.food_id && line.new_food_confirmed !== true
    && (line.identity_error === true || candidates.length > 0);
}
